import { render } from "./InscricaoPage.vue?vue&type=template&id=643018bd&scoped=true"
import script from "./InscricaoPage.vue?vue&type=script&lang=js"
export * from "./InscricaoPage.vue?vue&type=script&lang=js"

import "./InscricaoPage.vue?vue&type=style&index=0&id=643018bd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643018bd"]])

export default __exports__